import React, { useState, useEffect } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import RootState from 'typings/RootState'
import { connect, useDispatch } from 'react-redux'
import { setCurrentActivity } from 'features/maincon/activity/actions'
import {
  userEmailSelector,
  serviceTokenSelector,
} from 'features/sensitive/sensitive.selector'
import { EventModal } from 'Components/Shared'
import Menu from 'Components/MenuAdmin/AdminQCMenu'

import Breadcrumbs from './Breadcrumbs'
import styled from 'styled-components'
import { getReportDetail } from 'features/adminReport/commissioning/api'
import { GetReportDetailReq } from 'features/adminReport/commissioning/types'
import { toNumber } from 'lodash'
import ReportDetail from './ReportDetail'

type FormProps = {
  id: string
}

type Props = FormProps &
  RouteComponentProps<{
    projectCode: string
    id: string
    checkNo: string
    requestID: string
  }> &
  ReduxProps

const CommissioningDetail = (props: Props) => {
  const [lastPage, setLastPage] = useState('')

  const [enable, setEnable] = useState(false)
  const { Token, UserEmail, match, data, event } = props

  const ActivityID = match.params.id
  const CheckNumber = match.params.checkNo
  const RequestID = match.params.requestID
  const ProjectCode = match.params.projectCode

  const onPageClose = () => {
    if (lastPage !== '') {
      setLastPage('')
    }
  }

  const dispatch = useDispatch()

  useEffect(() => {
    setEnable(false)
  }, [data])

  useEffect(() => {
    onGetActivityDetail()
  }, [UserEmail, ProjectCode, ActivityID, Token, dispatch])

  const onGetActivityDetail = () => {
    setEnable(true)
    const data: GetReportDetailReq = {
      ProjectCode,
      UserEmail,
      ActivityID,
      CheckNumber: toNumber(CheckNumber),
      RequestID: toNumber(RequestID),
    }
    dispatch(getReportDetail(Token, data))
  }

  const onSuccess = () => {
    setEnable(false)
    onGetActivityDetail()
  }

  return (
    <>
      <EventModal
        name="activity"
        event={[event]}
        enable={enable}
        successCalback={onSuccess}
      />
      <Breadcrumbs />
      <Menu selected={'report.zone'}>
        <ReportDetail data={data} />
      </Menu>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    UserEmail: userEmailSelector(state),
    Token: serviceTokenSelector(state),
    data: state.adminReportCommission.DataDetail,
    event: state.adminReportCommission.Event,
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {
  setCurrentActivity,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommissioningDetail)
